import { FC } from 'react';
import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

import Typography from '../Typography';
import { BadgeProps, BadgeVariant } from './types';

const Badge: FC<BadgeProps> = ({ label, maxWidth, noWrap, variant }) => {
  return (
    <StyledBadge variant={variant}>
      <Typography variant='font12' noWrap={noWrap} maxWidth={maxWidth}>
        {label}
      </Typography>
    </StyledBadge>
  );
};

const getVariantToBackgroundColor = (theme: Theme) => ({
  error: theme.palette.colors.red[100],
  inverse: theme.palette.colors.slate[500],
  macro: theme.palette.colors.slate[100],
  outlined: 'transparent',
  outlinedInverse: 'transparent',
  success: theme.palette.colors.green[100],
  warning: theme.palette.colors.yellow[100],
});

const getVariantToTextColor = (theme: Theme) => ({
  error: theme.palette.colors.red[500],
  inverse: theme.palette.colors.white,
  macro: theme.palette.colors.grey[700],
  outlined: theme.palette.colors.black,
  outlinedInverse: theme.palette.colors.white,
  success: theme.palette.colors.green[600],
  warning: theme.palette.colors.yellow[600],
});

const getVariantBorderColor = (theme: Theme) => ({
  error: theme.palette.colors.red[100],
  inverse: theme.palette.colors.slate[500],
  macro: theme.palette.colors.slate[100],
  outlined: theme.palette.colors.black,
  outlinedInverse: theme.palette.colors.white,
  success: theme.palette.colors.green[100],
  warning: theme.palette.colors.yellow[100],
});

const StyledBadge = styled('div')<{ variant: BadgeVariant }>`
  align-items: center;
  background-color: ${p => getVariantToBackgroundColor(p.theme)[p.variant]};
  border-radius: 4px;
  color: ${p => getVariantToTextColor(p.theme)[p.variant]};
  border: 1px solid ${p => getVariantBorderColor(p.theme)[p.variant]};
  display: inline-flex;
  justify-content: center;
  padding: 4px 8px;
  text-align: center;
  min-height: 26px;
  box-sizing: border-box;
`;

export default Badge;
